import { createFileRoute } from '@tanstack/react-router';
import { JobTypesPage } from './jobtypes';

export const Route = createFileRoute('/_dashboard/dashboard/settings/jobtypes/$id')({
  component: JobTypesPage,
});
